module.exports = __webpack_public_path__ + "nc_static/media/labwater-logo-blue.b05ed776.png";